<template>
  <div class="solutions-wrapper">
    <div
      v-for="(solution, index) in solutionNames"
      :id="`solution-${solution}-wrapper`"
      :ref="`solution-${solution}-wrapper`"
      :key="solution"
      class="solution cursor-pointer"
      :class="[`solution-${solution}`, {'tourActive': tourCurrentStep >= 0 && (tourCurrentTarget === '#solution-four-wrapper')}]"
      @click="solve(index + 1)"
    >
      <span
        v-if="!isTouchDevice"
        class="key-number"
        :class="{'d-none': !(getRoundInfo().solutionType === '3DVIEW')}"
      >
        <small>Lösung {{ index + 1 }}</small>
      </span>
      <canvas
        :id="`solution-${solution}`"
        :ref="`solution-${solution}`"
        :class="{'d-none': !(getRoundInfo().solutionType === '3DVIEW')}"
      />
      <img
        v-if="getRoundInfo().solutionType === 'SLICE'"
        :src="solutions[index].solutionImagePath"
        class="solution-image"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import '@/vendor/STLLoader.js'
import * as THREE from 'three'
import Level from '@/lib/level'
const loaderSTL = new THREE.STLLoader()

export default {
  name: 'Solutions',
  props: {
    isTouchDevice: {
      type: Boolean,
      default: undefined
    },
    tourCurrentStep: {
      type: Number,
      default: undefined
    },
    tourCurrentTarget: {
      type: String,
      default: undefined
    },
    stackCenter: {
      type: THREE.Vector3,
      default: undefined
    }
  },
  data: function () {
    return {
      solutionNames: ['one', 'two', 'three', 'four'],
      solutions: [],
      allSolutionImagePaths: [
        'Slice1.png',
        'Slice2.png',
        'Slice3.png',
        'Slice4.png'
      ],
      solutionImagePaths: [],

      VIEW_ANGLE: 45,
      NEAR: 0.1,
      FAR: 10000,

      spherePath: '/sphere.stl',
      cylinderPath: '/cylinder.stl',
      cubePath: '/cube.stl',
      sondeModelPath: '/SondeModelS.stl'
    }
  },
  mounted () {
    this.solutions = this.solutionNames.map(solutionName => ({
      canvas: this.$refs[`solution-${solutionName}`][0],
      wrapper: this.$refs[`solution-${solutionName}-wrapper`][0],
      cube: {},
      cylinder: {},
      sphere: {}
    }))
    this.solutions.forEach(element => {
      element.canvas.width = 0
      element.canvas.height = 0
      element.sizeX = element.wrapper.offsetWidth
      element.sizeY = element.wrapper.offsetHeight
    })
    this.setup()
    setTimeout(() => {
      this.addGeometries()
    }, 1)
  },
  methods: {
    baller (junge) {
      console.log(junge)
    },
    getRandomSolutionImagePath () {
      if (Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound].allSolutionImagePaths) {
        let randomNumber = Math.floor(Math.random() * Math.floor(Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound].allSolutionImagePaths.length))
        if (Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound].allSolutionImagePaths[randomNumber] === Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound].correctSolution.solutionImagePath) {
          return this.getRandomSolutionImagePath()
        } else {
          return Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound].allSolutionImagePaths[randomNumber]
        }
      }
    },
    getRoundInfo () {
      return Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound]
    },
    loadLevel (gameToLoad, roundToLoad) {
      let correctSolution = Level[gameToLoad].rounds[roundToLoad].correctSolution

      for (let index in this.solutions) {
        index = +index
        const solution = this.solutions[index]
        if (index === (correctSolution.solutionNumber - 1)) {
          this.$set(this.solutions, index, {
            ...solution,
            solutionNumber: correctSolution.solutionNumber,
            solutionImagePath: './solutionImages/' + correctSolution.solutionImagePath,
            cube: {
              ...solution.cube,
              ...correctSolution.cube
            },
            cylinder: {
              ...solution.cylinder,
              ...correctSolution.cylinder
            },
            sphere: {
              ...solution.sphere,
              ...correctSolution.sphere
            },
            correct: true
          })
        } else {
          this.$set(this.solutions, index, {
            ...solution,
            correct: false,
            solutionNumber: index + 1,
            solutionImagePath: './solutionImages/' + this.getRandomSolutionImagePath(),
            cube: {
              ...solution.cube,
              scale: 18.5,
              x: Math.random() * (70 - 10) + 10,
              y: Math.random() * (70 - 10) + 10,
              z: Math.random() * (70 - 10) + 10
            },
            cylinder: {
              ...solution.cylinder,
              scale: 18.5,
              x: Math.random() * (70 - 10) + 10,
              y: Math.random() * (70 - 10) + 10,
              z: Math.random() * (70 - 10) + 10
            },
            sphere: {
              ...solution.sphere,
              scale: 18.5,
              x: Math.random() * (70 - 10) + 10,
              y: Math.random() * (70 - 10) + 10,
              z: Math.random() * (70 - 10) + 10
            }
          })
        }
      }
    },
    setup () {
      for (const element of this.solutions) {
        element.camera = new THREE.PerspectiveCamera(this.VIEW_ANGLE, element.sizeX / element.sizeY, this.NEAR, this.FAR)
        element.camera.position.set(150, 150, 150)
        element.camera.lookAt(0, 0, 0)

        element.renderer = new THREE.WebGLRenderer({
          antialias: true,
          canvas: element.canvas
        })
        element.renderer.setClearColor(0x121339, 1)
        element.renderer.setSize(element.sizeX, element.sizeY)

        element.scene = new THREE.Scene()
        element.scene.add(new THREE.AmbientLight(0xffffff))
        element.scene.add(element.camera)

        // element.scene.add(new THREE.AxesHelper(50))
      }
    },
    async addGeometries () {
      for (const element of this.solutions) {
        await Promise.all([
          new Promise(resolve => {
            loaderSTL.load(this.cubePath, geometry => {
              var material = new THREE.MeshLambertMaterial({ color: 0x970064 })
              var mesh = new THREE.Mesh(geometry, material)
              mesh.rotation.y = Math.PI / 2
              element.cube.model = mesh
              element.scene.add(element.cube.model)
              resolve()
            })
          }),
          new Promise(resolve => {
            loaderSTL.load(this.cylinderPath, geometry => {
              var material = new THREE.MeshLambertMaterial({ color: 0x009764 })
              var mesh = new THREE.Mesh(geometry, material)
              mesh.rotation.y = Math.PI / 2
              element.cylinder.model = mesh
              element.scene.add(element.cylinder.model)
              resolve()
            })
          }),
          new Promise(resolve => {
            loaderSTL.load(this.spherePath, geometry => {
              var material = new THREE.MeshLambertMaterial({ color: 0x988E65 })
              var mesh = new THREE.Mesh(geometry, material)
              mesh.rotation.y = Math.PI / 2
              element.sphere.model = mesh
              element.scene.add(element.sphere.model)
              resolve()
            })
          })
        ])
      }
    },
    solve (solution) {
      if (solution === this.solutions.find(element => element.correct === true).solutionNumber) {
        this.solved()
      } else {
        this.wrongSolution()
      }
    },
    solved () {
      this.$emit('solutionModal', {
        visible: true,
        correct: true
      })
    },
    wrongSolution () {
      this.$emit('solutionModal', {
        visible: true,
        correct: false
      })
    },
    setSize () {
      for (const element of this.solutions) {
        element.renderer.setSize(0, 0)
        element.canvasSizeX = element.wrapper.offsetWidth
        element.canvasSizeY = element.wrapper.offsetHeight - 6
        element.renderer.setSize(element.canvasSizeX, element.canvasSizeY)
        element.camera.aspect = element.canvasSizeX / element.canvasSizeY
        element.camera.updateProjectionMatrix()
      }
    },
    render () {
      for (const element of this.solutions) {
        if (element.cube.model && element.cylinder.model && element.sphere.model) {
          element.cube.model.scale.set(element.cube.scale, element.cube.scale, element.cube.scale)
          element.cube.model.position.set(element.cube.x, element.cube.y, element.cube.z)

          element.cylinder.model.scale.set(element.cylinder.scale, element.cylinder.scale, element.cylinder.scale)
          element.cylinder.model.position.set(element.cylinder.x, element.cylinder.y, element.cylinder.z)

          element.sphere.model.scale.set(element.sphere.scale, element.sphere.scale, element.sphere.scale)
          element.sphere.model.position.set(element.sphere.x, element.sphere.y, element.sphere.z)
        }
      }
      for (const element of this.solutions) {
        if (element.camera && this.$store.state.rotateSolution && this.$store.state.stackCenter) {
          element.camera.position.set(this.$store.state.stackCenter.x + (Math.sin(Math.PI * this.$store.state.rotateSolution) * 200), 100, this.$store.state.stackCenter.z + (Math.cos(Math.PI * this.$store.state.rotateSolution)) * 200)
          element.camera.lookAt(this.$store.state.stackCenter.x, this.$store.state.stackCenter.y, this.$store.state.stackCenter.z)
        }
      }
      this.solutions.forEach(element => {
        element.renderer.render(element.scene, element.camera)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style.scss';
.solutions-wrapper{
  grid-area: sol;
  display: grid;
  grid-column-gap: $gutter;
  grid-row-gap: 0;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "sol1 sol2 sol3 sol4";
  .solution{
    background-color: $bg-light;
    position: relative;
    max-height: 100%;
    overflow: hidden;
    .key-number{
      $bubbleSize: 20px;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: 5px;
      right: 5px;
      padding-left: 10px;
      padding-right: 10px;
      height: $bubbleSize;
      background-color: $cyan;
      color: $bg-light;
      border-radius: 4px
    }
    .solution-image{
      width: 100%;
      max-height: 100px;
      object-fit: contain;
    }
    &.solution-one{
      grid-area: sol1;
      canvas{
        width: 0;
      }
    }
    &.solution-two{
      grid-area: sol2;
      canvas{
        width: 0;
      }
    }
    &.solution-three{
      grid-area: sol3;
      canvas{
        width: 0;
      }
    }
    &.solution-four{
      grid-area: sol4;
      canvas{
        width: 0;
      }
    }
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .solutions-wrapper{
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    grid-template-areas: "sol1" "sol2" "sol3" "sol4";
    grid-column-gap: 0;
    grid-row-gap: $gutter;
  }
}
</style>
